import React, { useState } from 'react';

const Topbar = ({ user, onLogout, onToggleSidebar }) => {
  const [showDropdown, setShowDropdown] = useState(false);

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const handleLogout = () => {
    setShowDropdown(false);
    onLogout();
  };

  return (
    <div className="topbar">
      <div className="d-flex align-items-center">
        <button 
          className="btn btn-link d-md-none" 
          onClick={onToggleSidebar}
          style={{ color: '#495057' }}
        >
          ☰
        </button>
        <h4 className="mb-0 ms-2 d-none d-md-block">Api Reporting</h4>
      </div>
      
      <div className="d-flex align-items-center">
        <div className="me-3 d-none d-md-block">
          <small className="text-muted">
            {new Date().toLocaleDateString('en-US', { 
              weekday: 'long', 
              year: 'numeric', 
              month: 'long', 
              day: 'numeric' 
            })}
          </small>
        </div>
        
        <div className="dropdown">
          <button
            className="btn btn-link dropdown-toggle d-flex align-items-center"
            type="button"
            onClick={toggleDropdown}
            style={{ textDecoration: 'none', color: '#495057' }}
          >
            <div className="me-2">
              <img 
                src="/images/profile.jpg"
                alt="Profile"
                className="rounded-circle"
                style={{ 
                  width: '48px', 
                  height: '48px', 
                  objectFit: 'cover',
                  border: '2px solid #ccc'
                }}
              />
            </div>
            <span>{user?.username || 'User'}</span>
          </button>
          
          {showDropdown && (
            <div className="dropdown-menu dropdown-menu-end show" style={{ right: 0 }}>
              <div className="dropdown-header">
                <strong>{user?.username}</strong>
                <br />
                <small className="text-muted">{user?.role || 'Admin'}</small>
              </div>
              {/* <div className="dropdown-divider"></div>
              <a className="dropdown-item" href="#profile">
                👤 Profile
              </a>
              <a className="dropdown-item" href="#settings">
                ⚙️ Settings
              </a> */}
              <div className="dropdown-divider"></div>
              <button className="dropdown-item" onClick={handleLogout}>
                🚪 Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Topbar; 